import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "saveljevs_extended_contract" }) {
    ...NewsInfoEn
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Midfielder of the Latvian national team and Italian Serie A club Hellas Verona Aleksejs Saveljevs has extended his contract with Catenaccio Sports Agency.</p>
        </div>
      </div>
    )
  }
}